import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentUser } from '../features/auth/authSlice';

/**
 * Loads profile + subscription when a session exists.
 * Login/signup may include subscription in the response; otherwise GET /user is used.
 */
const AuthInitializer = ({ children }) => {
  const dispatch = useDispatch();
  const { token, user, status } = useSelector((state) => state.auth);
  const userSubscription = useSelector((state) => state.subscription?.userSubscription);
  const missingSubscriptionFetchRef = useRef(false);

  useEffect(() => {
    const storedToken = localStorage.getItem('auth_token');
    if (!storedToken) {
      missingSubscriptionFetchRef.current = false;
      return;
    }

    if (!user && status === 'idle') {
      dispatch(getCurrentUser());
      return;
    }

    if (
      user
      && !userSubscription
      && status === 'succeeded'
      && !missingSubscriptionFetchRef.current
    ) {
      missingSubscriptionFetchRef.current = true;
      dispatch(getCurrentUser());
    }
  }, [dispatch, token, user, status, userSubscription]);

  useEffect(() => {
    if (userSubscription) {
      missingSubscriptionFetchRef.current = false;
    }
  }, [userSubscription]);

  return <>{children}</>;
};

export default AuthInitializer;
